import type { ObjectId } from 'mongodb';

import type { ApprovedVendorAlias } from './ApprovedVendorList';
import type { EntityHistoryEntry, Meta } from './Entities';
import type { ProgramType } from './ProgramTypes';

/**
 * Whether we still support this manufacturer or brand. Distinct from `meta.status`, which is the
 * soft-delete tombstone: an `inactive` record stays readable, stays attached to historical packages,
 * and can be brought back.
 */
export enum EquipmentRecordStatus {
  active = 'active',
  inactive = 'inactive',
}

/** OEM corporate parent, e.g. Trane, Daikin, `JCI (Bosch)`. */
export interface EquipmentManufacturerDocument {
  id: ObjectId;
  name: string;
  /** Program scoping lives on the manufacturer only, never on its brands. */
  programTypes: ProgramType[];
  status: EquipmentRecordStatus;
  aliases: ApprovedVendorAlias[];
  history: EntityHistoryEntry[];
  meta: Meta;
}

/** Nameplate under a manufacturer, e.g. Goodman, Payne, York. */
export interface EquipmentBrandDocument {
  id: ObjectId;
  manufacturerId: ObjectId;
  name: string;
  websiteUrl?: string;
  warrantyRegistrationUrl?: string;
  status: EquipmentRecordStatus;
  aliases: ApprovedVendorAlias[];
  history: EntityHistoryEntry[];
  meta: Meta;
}
